export default __webpack_public_path__ + "static/media/image4.c482fbf3.jpg";